import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('SubscribedUserDrawer').create(({ theme }) => ({
  root: {
    display: 'flex',

    position: 'relative',
    flexDirection: 'column',
    alignItems: 'center',
    pointerEvents: 'all',
    overflowX: 'hidden',

    width: '100vw',
    height: '100%',

    gap: '8px',
    paddingTop: '44px',
  },
  blurCircle: {
    position: 'absolute',
    filter: 'blur(55px)',
    aspectRatio: '1/1',
    top: '0px',
    right: '0px',
    borderRadius: '99px',
    width: '300px',
    height: '300px',
    background: 'radial-gradient(50% 50% at 50% 50%, rgba(27, 151, 255, 0.5) 14.5%, rgba(0, 0, 0, 0) 100%)',
    overflow: 'hidden',
  },
  heading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: '24px',
    paddingBottom: '32px',

    span: {
      fontFamily: 'Inter',
      fontWeight: 350,
      fontSize: '13px',
      lineHeight: '18px',
      textAlign: 'center',
      color: theme.colors.text.secondary,
      padding: '0px 12px',
    },
  },

  logosWrapper: {
    display: 'flex',
    gap: '8px',
  },

  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },

  valueText: {
    color: '#757778'
  },

  imageIconWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  columns: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '10px',
    width: '90%',

    img: {
      paddingTop: '0px',
    },
  },

  featureText: {
    fontFamily: 'Inter',
    fontWeight: 370,
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: 'rgba(117, 119, 120, 1)',
    textTransform: 'uppercase',
  },

  basicText: {
    fontFamily: 'Inter',
    fontWeight: 550,
    fontSize: '13px',
    lineHeight: '18px',
    color: theme.colors.text.primary,
  },

  plusAndTextWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingRight: '4px',
  },

  plusText: {
    fontFamily: 'Inter',
    fontWeight: 450,
    fontSize: '13px',
    lineHeight: '18px',
    // color: 'rgba(74, 107, 252, 1)',
  },

  featureListWrapper: {
    width: '100%',
    overflow: 'hidden',
    paddingBottom: '100px',
  },

  featureList: {
    width: '100%',

    height: '100%',
    padding: '0 5vw',
    display: 'flex',

    flexDirection: 'column',
    overflow: 'scroll',
    gap: '12px',
    paddingBottom: '12px',
  },

  featureListItem: {
    display: 'flex',
    width: '100%',
    height: '46px',
    padding: '10px',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.colors.background.secondary,

    ':first-child': {
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },

    ':last-child': {
      borderBottomLeftRadius: '12px',
      borderBottomRightRadius: '12px',
    },
  },

  BasicAndPlusWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '40%',
  },

  nameAndLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  featureName: {
    fontFamily: 'Inter',
    fontWeight: 300,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.l,

    color: theme.colors.text.primary,
  },

  availabilityWrapper: {
    padding: '0px 14px',
    display: 'flex',
  },

  controlsWrapper: {
    width: '100%',
    padding: '0px 5%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },

  buttons: {
    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    width: '100%',
    bottom: '-14px',
    zIndex: '3',
    '&::before': {
      position: 'absolute',
      width: '100%',
      height: '60px',
      top: '-60px',
      left: '0px',
      content: '""',
      zIndex: 2,
      background: 'linear-gradient(0deg, rgba(29,30,34,1) 0%, rgba(29,30,34,.4) 50% , rgba(51,169,224,0) 100%)',
    },
  },

  button: {
    height: '44px',
    position: 'relative',
    backgroundColor: '#1c1e22',
    boxShadow: 'none',
    border: '1px solid rgba(255, 255, 255, 0.09)',
    zIndex: 4,
  },

  validText: {
    fontFamily: 'Inter',
    fontWeight: 360,
    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    paddingBottom: '6px',
    textAlign: 'center',
    color: 'rgba(250, 252, 255, 0.65)',
    zIndex: 4,
  },
}))
